import {  Label, DataSourceMode } from "@mcleod/components";
import { AutogenLayoutCarrierImages } from "./autogen/AutogenLayoutCarrierImages";
export class CarrierImages extends AutogenLayoutCarrierImages {



}
